
import type { Property } from 'csstype'

type RGBColor = `rgb(${number}, ${number}, ${number})`;

export function ResolveCSSColor(color: Property.Color): RGBColor {
  const template = document.createElement('template')
  template.style.color = color;
  document.body.appendChild(template)
  const result = getComputedStyle(template).color;
  template.remove()
  return result as RGBColor;
}
